import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: (resolve) => {
        require(['../views/index'], resolve)
      },
      children: [
        {
          path: '',
          component: (resolve) => {
            require(['../views/home/app'], resolve)
          }
        },
        {
          path: '/contact',
          component: (resolve) => {
            require(['../views/contactUs/app'], resolve)
          }
        },
        // {
        //   path: '/apply',
        //   component: (resolve) => {
        //     require(['../views/applyTry/app'], resolve)
        //   }
        // },
        {
          path: '/license',
          component: (resolve) => {
            require(['../views/license/app'], resolve)
          }
        },
        {
          path: '/about',
          component: (resolve) => {
            require(['../views/aboutUs/app'], resolve)
          }
        },
        {
          path: '/developer',
          component: (resolve) => {
            require(['../views/developer/app'], resolve)
          }
        },
        {
          path: '/introduction/:id',
          name: 'introduction',
          component: (resolve) => {
            require(['../views/introduction/app'], resolve)
          }
        },
        {
          path: '/product/:id',
          name: 'product',
          component: (resolve) => {
            require(['../views/product/app'], resolve)
          }
        },
        {
          path: '/solution/:id',
          name: 'solution',
          component: (resolve) => {
            require(['../views/solution/app'], resolve)
          }
        },
        {
          path: '/download',
          name: 'download',
          component: (resolve) => {
            require(['../views/download/app'], resolve)
          }
        },
        {
          path: '/productPage',
          name: 'productPage',
          component: (resolve) => {
            require(['../views/productPage/app'], resolve)
          }
        },
        {
          path: '/maintenancePolicy',
          name: 'maintenancePolicy',
          component: (resolve) => {
            require(['../views/maintenancePolicy/app'], resolve)
          }
        },
        {
          path: '/advantage',
          name: 'advantage',
          component: (resolve) => {
            require(['../views/advantage/app'], resolve)
          }
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    const position = {}
    if (to.hash) {
      position.selector = to.hash
      position.offset = { y: 100 }
      if (document.querySelector(to.hash)) {
        return position
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js